module.exports = __webpack_public_path__ + "img/payment-logos-mastercard.9fd2ec35.png";